// store/store.tsx - FIXED VERSION with Template Slice
import { configureStore } from '@reduxjs/toolkit'; 
import { persistReducer, persistStore } from 'redux-persist'; 
import storage from 'redux-persist/lib/storage'; 
import { combineReducers } from 'redux'; 
import socketReducer from './slices/socketSlice'; 
import socketMiddleware from './middleware/socketMiddleware';

// Import slices 
import conversationsReducer from './slices/conversationsSlice'; 
import messagesReducer from './slices/messagesSlice'; 
import mediaReducer from './slices/mediaSlice'; 
import uiReducer from './slices/uiSlice'; 
import userReducer from './slices/userSlice';
import teamReducer from './slices/teamSlice';
import templateReducer from './slices/templateSlice'; // ← ADD: Import template slice

// Combine reducers from existing app 
import { rootReducer as existingRootReducer } from '../reducers/rootReducer';
import { TeamState } from '../types/team.types';
import { TemplateState } from './slices/templateSlice'; // ← ADD: Import template state type
import logger from '../utils/logger';
import { ContentState } from './slices/contentSlice';
import contentReducer from './slices/contentSlice';

// Log start of store creation
logger.log("Starting Redux store configuration...");

// Persist configuration - ADD templates to whitelist
const persistConfig = { 
  key: 'root', 
  version: 1, 
  storage, 
  whitelist: ['user', 'conversations', 'rootReducers', 'team', 'templates'], // ← ADD: templates 
};

logger.log("Persist config:", persistConfig);

// ← FIXED: WhatsApp feature reducers with template slice
const whatsappReducers = combineReducers({ 
  conversations: conversationsReducer, 
  messages: messagesReducer, 
  media: mediaReducer, 
  ui: uiReducer, 
  user: userReducer, 
  socket: socketReducer,
  team: teamReducer,
  templates: templateReducer, // ← ADD: Template slice
    content: contentReducer,
});

// ← FIXED: Define WhatsApp state type with template state
export interface WhatsAppState {
  conversations: any; 
  messages: any; 
  media: any; 
  ui: any; 
  user: any; 
  socket: any; 
  team: TeamState;
  templates: TemplateState; // ← ADD: Template state
    content: ContentState;
}

// Simple action logger
const actionLogger = (store: any) => (next: any) => (action: any) => {
  if (action.type === 'SET_PREFERENCES') {
    logger.log('🔧 PREFERENCES ACTION:', action.type);
  }
  
  // ← ADD: Log template actions
  if (action.type.startsWith('templates/')) {
    logger.log('🎨 TEMPLATE ACTION:', action.type);
  }
  
  return next(action);
};

// Combine with existing reducers 
const combinedReducers = combineReducers({ 
  rootReducers: existingRootReducer, 
  whatsapp: whatsappReducers, // ← This now includes templates
});

logger.log("Combined reducers structure:", Object.keys(combinedReducers));
logger.log("WhatsApp reducers include:", Object.keys(whatsappReducers));

// Create persisted reducer 
const persistedReducer = persistReducer(persistConfig, combinedReducers);

logger.log("Created persisted reducer with template caching support");

// Configure store
export const store = configureStore({ 
  reducer: persistedReducer, 
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware({ 
      serializableCheck: { 
        ignoredActions: [
          'persist/PERSIST', 
          'persist/REHYDRATE',
        ], 
      }, 
    }).concat(socketMiddleware).concat(actionLogger), // ← ADD: action logger
});

logger.log("Store created, initial state structure:", Object.keys(store.getState()));
logger.log("WhatsApp state includes:", Object.keys(store.getState().whatsapp));
logger.log("Template slice available:", !!store.getState().whatsapp.templates);

// Add subscription to track template changes
store.subscribe(() => {
  const state = store.getState();
  const templateStats = state.whatsapp?.templates;
  if (templateStats) {
    logger.log("🎨 Template Cache Status:", {
      totalCached: templateStats.totalCached,
      templateCount: Object.keys(templateStats.templates).length,
    });
  }
});

// Export persistor 
export const persistor = persistStore(store);

// ← FIXED: Updated RootState type to include template
export type RootState = ReturnType<typeof store.getState>; 
export type AppDispatch = typeof store.dispatch;